<template lang="pug">
  div.neutral700--text
    .d-flex.justify-space-between.align-center.mb-4
      .text-lg.font-semibold +{{ phone }}
      v-btn(icon @click="handleEditInfo")
        v-icon(size="20") $yzi-edit-05
    .d-flex.justify-space-between.align-center.mb-2
      .text-sm.font-semibold Name
      .text-sm(v-if="name") {{ name }}
      .text-sm.neutral500--text(v-else) No name
    .d-flex.justify-space-between.align-center.mb-2
      .text-sm.font-semibold.neutral700--text Total spend
      .text-sm {{ totalSpend | displayPrice }}
    .d-flex.justify-space-between.align-center.mb-2
      .text-sm.font-semibold.neutral700--text {{ loyaltySystem === 'stamps' ? 'Stamps' : 'Points balance' }}
      stamp-collections(v-if="loyaltySystem === 'stamps'" :stamp-collected="valueCollected" :rewards-position="rewardsPosition")
      .text-md.font-semibold(v-else) {{ valueCollected }} points
    .dialogs
      edit-info(v-if="editInfo.open" :open.sync="editInfo.open" :parent-id="memberId" :parent-name="name" :parent-phone="phone" :parent-email="email" :parent-dob="dob")
</template>

<script>
import EditInfo from "@/components/marketing/merchantapp/bottomdialogs/EditInfo.vue";
import StampCollections from "@/components/marketing/merchantapp/stamps/StampCollections.vue";
import {mapGetters} from "vuex";

export default {
  components: {
    StampCollections,
    EditInfo
  },
  props: {
    loyaltySystem: {
      type: String,
      required: true
    },
    memberId: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      default: null
    },
    phone: {
      type: String,
      required: true
    },
    email: {
      type: String,
      default: null
    },
    dob: {
      type: String,
      default: null
    },
    totalSpend: {
      type: Number,
      default: 0
    },
    valueCollected: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      editInfo: {
        open: false,
        data: null
      }
    }
  },
  computed: {
    ...mapGetters({
      loyaltySettings: 'marketing/getLoyaltySettings'
    }),
    rewardsPosition() {
      return this.loyaltySettings?.rewards?.map(reward => reward.tier_value) || []
    },
  },
  methods: {
    handleEditInfo() {
      this.editInfo.open = true
    }
  },
}
</script>

<style scoped>
</style>